/**
 * Module definition houses api implementation.
 *
 * @module stack.common.api
 */
angular.module('stack.common.api', [
  'stack.common.api.stackApi',
  'stack.common.api.ApiController',
  'stack.common.api.ApiService',
  'stack.common.api.models',
  'stack.common.api.validation',
  'stack.common.api.queue'
]);
